module.exports = __webpack_public_path__ + "img/teamwork-icon-2.a97733c8.png";